import React from 'react'
import { useMutation } from 'react-query'
import { AnimalProfilesClient } from '../../../../interactors/clients/AnimalProfilesClient'
import { AnimalProfileDto } from '../../../../interactors/gen/backendClient'
import { useGlobalSnackbarStore } from '../../../../store/GlobalSnackBarStore'
import { Categories } from '../AnimalHealthTab'
import { BehaviorInitialQuestions } from '../BehaviorInitialQuestions'
import { EditBehaviorQuestions } from '../EditBehaviorQuestions'

interface Props {
  animalProfile: AnimalProfileDto
  setAnimalProfile: (animalProfile: AnimalProfileDto) => void
  setSelectedCategory: (category: Categories) => void
}

export const Behavior: React.FC<Props> = ({ animalProfile, setAnimalProfile, setSelectedCategory }) => {
  const globalSnackbarStore = useGlobalSnackbarStore()
  const mutation = useMutation(
    (animal: AnimalProfileDto) => {
      return AnimalProfilesClient.editAnimalProfile(animal)
    },
    {
      onSuccess: (animal) => {
        setAnimalProfile(animal)
        globalSnackbarStore.triggerSuccessMessage("Profil de l'animal mis à jour")
        setSelectedCategory(Categories.Score)
      },
      onError: (error) => {
        console.error('Error updating animal profile', error)
        globalSnackbarStore.triggerErrorMessage("Une erreur est survenue lors de la mise à jour du profil de l'animal")
      },
    }
  )
  if (animalProfile.health.score?.behaviorQuestions && animalProfile.health.score?.behaviorQuestions.length > 0) {
    return <EditBehaviorQuestions animalProfile={animalProfile} editMutation={mutation} />
  } else {
    return <BehaviorInitialQuestions animalProfile={animalProfile} editMutation={mutation} />
  }
}
